<template>
  <div class="page wrapper">
    <div class="banner">
      <img src="../../assets/images/activity/20-double-eleven_banner.png">
    </div>

    <div class="info">
      <div class="info-title">
        <img src="../../assets/images/activity/20-double-eleven_info-title.png">
        <!-- <span>每日做任务</span>
        <span>金币自然来</span> -->
      </div>

      <div class="info-num">
        <div>当前金币余量：<b>{{ coinTotal }}</b></div>
        <div>所有剩余金币将于11月12日0点清零失效</div>
      </div>

      <div class="info-progress">
        <div class="info-task task-one">
          <div class="task-one-icon">
            <div class="task-icon-wrapper">
              <img src="../../assets/images/activity/20-double-eleven_task-one.png">
            </div>
            <div>任务一</div>
          </div>
          <div class="task-progress">
            <div class="progress-bar">
              <div class="progress-bar-content" :style="'width:' + (taskOne.CmplNum / taskOne.total * 180) +'px'"></div>
            </div>
            <div>每日签到即可获得<b> 50 </b>金币</div>
          </div>
          <div class="task-completion">
            <span>{{ `${taskOne.CmplNum}/${taskOne.total}` }}</span>
            <div @click="jumpToCmplTask('task-1')">{{ taskOne.CmplNum === taskOne.total ? '已完成' : '去完成' }}</div>
          </div>
        </div>

        <div class="info-task task-two">
          <div class="task-one-icon">
            <img src="../../assets/images/activity/20-double-eleven_task-two.png">
            <div>任务二</div>
          </div>
          <div class="task-progress">
            <div class="progress-bar">
              <div class="progress-bar-content" :style="'width:' + (taskTwo.CmplNum / taskTwo.total * 180) +'px'"></div>
            </div>
            <div>每日浏览商品页面即可有<b> 3 </b>次机会获得金币，金币数额随机</div>
          </div>
          <div class="task-completion">
            <span>{{ `${taskTwo.CmplNum}/${taskTwo.total}` }}</span>
            <div @click="jumpToCmplTask('task-2')">{{ taskTwo.CmplNum === taskTwo.total ? '已完成' : '去完成' }}</div>
          </div>
        </div>
      </div>

      <div class="prize">
        <div class="prize-title">
          <img src="../../assets/images/activity/20-double-eleven_prize-title.png">
          <!-- <span>对折福袋闭眼兑</span>
          <span>保证不会亏</span> -->
        </div>

        <div class="prize-info">
          <div class="prize-content">
            <div class="prize-icon">
              <img src="../../assets/images/activity/20-double-eleven_prize-one.png">
            </div>
            <!-- <div class="prize-name">爱自己</div> -->
            <div class="prize-points">兑换积分：15000</div>
            <div class="prize-btn" @click="jumpToGiftPage('prize-1')">立即兑购</div>
            <div class="prize-detail">
              <div>可能包含的礼品有</div>
              <div class="prize-detail-content">
                <div>
                  <img style="display:inline-block" src="../../assets/images/activity/20-double-eleven_G170462.png">
                </div>
                <div>
                  <img src="../../assets/images/activity/20-double-eleven_G170207.png">
                </div>
                <div>
                  <img src="../../assets/images/activity/20-double-eleven_G170205.png">
                </div>
              </div>
            </div>
          </div>

          <div class="prize-content">
            <div class="prize-icon">
              <img src="../../assets/images/activity/20-double-eleven_prize-two.png">
            </div>
            <!-- <div class="prize-name">也爱你</div> -->
            <div class="prize-points">兑换积分：12000</div>
            <div class="prize-btn" @click="jumpToGiftPage('prize-2')">立即兑购</div>
            <div class="prize-detail">
              <div>可能包含的礼品有</div>
              <div class="prize-detail-content">
                <div class="prize-special">
                  <img src="../../assets/images/activity/20-double-eleven_G170087.png">
                  <span>或</span>
                  <img src="../../assets/images/activity/20-double-eleven_G170092.png">
                </div>
                <div>
                  <img src="../../assets/images/activity/20-double-eleven_Z170078.png">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="rule">
      <div class="rule-detail">
        <div class="rule-level1-heading">活动细则：</div>
        <div class="rule-secondary-heading">活动一：</div>
        <div>11月10日做任务金币奖励翻倍；11月11日每消耗300金币可以获得一次抽奖机会。</div>
        <div class="rule-secondary-heading">活动二：</div>
        <div>福袋活动属于折扣福利，因此福袋中的礼品不可指定颜色、样式、尺寸，一旦兑换不可退换。</div>
      </div>

      <div class="rule-prize">
        <div class="rule-level1-heading">礼品发放：</div>
        <div>实物礼物：<span>所有实物礼品将在活动结束后陆续发货。</span></div>
        <div>积分奖品：<span>当月充值到账。</span></div>
      </div>

      <div class="rule-statement">
        <div class="rule-level1-heading">活动声明：</div>
        <div>本活动最终解释权归博世易加所有，有疑问请咨询客服。</div>
      </div>
    </div>

    <div v-show="!showLottoryWindow" class="floating" @click="showLottoryWindow = true">
      <img src="../../assets/images/activity/20-double-eleven_float.png">
    </div>

    <div class="lottory">
      <div class="lottory-wrapper" :style="showLottoryWindow ? 'right:0px' : ''">
        <div class="lottory-icon" @click="showLottoryWindow = false">
          <img src="../../assets/images/activity/20-double-eleven_close.png">
        </div>
        <div class="lottory-content">
          <img style="width:30px" src="../../assets/images/activity/20-double-eleven_first-prize.png">
          <div style="font-size:12px;padding-bottom:10px">博世AI音箱</div>
          <img src="../../assets/images/activity/20-double-eleven_second-prize.png">
          <div style="font-size:12px;padding-bottom:10px"> 小易三件套</div>
          <img src="../../assets/images/activity/20-double-eleven_points.png">
          <div style="font-size:12px">1111积分</div>
          <div class="lottory-btn" @click="handleLottoy">
            <img src="../../assets/images/activity/20-double-eleven_lottoy-btn.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import activityApi from '@/api/activity'
export default {
  name: 'DoubleEleven2020',
  data () {
    return {
      taskOne: {
        CmplNum: 0,
        total: 1
      },
      taskTwo: {
        CmplNum: 0,
        total: 3
      },
      coinTotal: 0,
      showLottoryWindow: false,
      activityId: '',
      activityCoinDTO: {},
      attendInfo: {}
    }
  },
  created () {
    this.getSeckillList()
    this.getUserActivityInfo()
  },
  methods: {
    // 获取活动id
    getSeckillList () {
      const params = {
        activityCode: 'coin-draw-202011',
        isPublish: '0'
      }
      activityApi.getSeckillList(params).then(response => {
        if (response.data.resultCode === '0') {
          const activityList = response.data.resultData.activityList || []
          if (activityList.length) {
            this.activityId = activityList[0].activityId
          }
        } else {
          this.$notify({
            background: '#1989fa',
            message: response.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch((error) => {
        console.log(error)
        this.$toast.clear()
      })
    },

    // 获取用户参与情况
    getUserActivityInfo () {
      const params = {
        activityCode: 'coin-draw-202011'
      }
      activityApi.getUserActivityInfo(params).then(response => {
        if (response.data.resultCode === '0') {
          this.activityCoinDTO = response.data.resultData.activityCoinDTO || {}
          this.coinTotal = this.activityCoinDTO.coinTotal
          this.taskOne.CmplNum = this.activityCoinDTO.alreadySign ? 1 : 0
          this.taskTwo.CmplNum = this.activityCoinDTO.browseAcquireCount ? this.activityCoinDTO.browseAcquireCount : 0
        } else {
          this.$notify({
            background: '#1989fa',
            message: response.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    // 抽奖
    handleLottoy () {
      // const currentTime = new Date()
      // if (currentTime < new Date('2020/11/11')) {
      //   this.$notify('活动将于11月11日开启')
      //   return
      // }
      // if (this.coinTotal < 300) {
      //   this.$notify('金币数不足')
      //   return
      // }
      const params = {
        activityId: this.activityId
      }
      activityApi.doubleEleven2020CoinDraw(params).then(response => {
        if (response.data.resultCode === '0') {
          this.attendInfo = response.data.resultData.attendInfo || {}
          let text = ''
          switch (this.attendInfo.prizeType) {
            case '01':
              text = '恭喜您获得1111积分'
              break
            case '03':
              if (this.attendInfo.itemCode === 'G170520') {
                text = '恭喜您获得小易IP三件套'
              } else if (this.attendInfo.itemCode === 'G170532') {
                text = '恭喜您获得大奖'
              }
              break
            case '09':
              text = '很遗憾未中奖'
              break
          }
          this.$toast(text)
          this.getUserActivityInfo()
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    // 跳转到任务页面
    jumpToCmplTask (type) {
      // 首页签到
      if (type === 'task-1' && this.taskOne.CmplNum < this.taskOne.total) {
        console.log('task-1')
        window.location.href = commonUtils.getExtraSite() + ''
      }
      // 浏览商品
      if (type === 'task-2' && this.taskTwo.CmplNum < this.taskTwo.total) {
        console.log('task-2')
        window.location.href = commonUtils.getExtraSite() + '/#/tab/sort//'
      }
    },
    // 跳转到礼品页面
    jumpToGiftPage (type) {
      if (type === 'prize-1') {
        window.location.href = commonUtils.getExtraSite() + '/#/goodsDetail/4879'
      }
      if (type === 'prize-2') {
        window.location.href = commonUtils.getExtraSite() + '/#/goodsDetail/4880'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  background: center/cover url('../../assets/images/activity/20-double-eleven_bg.png') no-repeat;
}
.wrapper {
  padding: 30px 10px 100px;
  .banner {
    margin-bottom: 30px;
    img {
      width: 100%;
    }
  }

  .info {
    padding: 25px 20px 40px;
    margin-bottom: 30px;
    text-align: center;
    background: rgba(144,147,153,.5);
    border-radius: 8px;
    .info-title {
      width: 100%;
      margin-bottom: 10px;
      img {
        width: 65%;
      }
      // color: #fff600;
      // font-size: 18px;
      // font-weight: 600;
      // margin-bottom: 10px;
      // span:nth-child(1) {
      //   margin-right: 30px;
      // }
    }

    .info-num {
      line-height: 20px;
      color: #fff;
      div:nth-child(1) {
        font-size: 16px;
        font-weight: 600;
        font-style: italic;
        b {
          color: #fff600;
        }
      }
      div:nth-child(2) {
        font-size: 12px;
      }
    }

    .info-progress {
      padding-top: 10px;
      .info-task {
        display: flex;
        justify-content: space-around;
        height: 90px;
        .task-one-icon {
          font-size: 16px;
          font-weight: 600;
          color: #fff;
          .task-icon-wrapper {
            width: 60px;
          }
          img {
            width: 50px;
          }
          div {
            padding-top: 5px;
          }
        }
      }
      .task-one {
        margin-bottom: 20px;
      }
      .task-two {
        .task-one-icon img {
          width: 60px;
        }
      }

      .task-progress {
        text-align: left;
        margin: auto;
        color: #fff;
        font-size: 12px;
        div {
          width: 180px;
        }
        .progress-bar {
          height: 10px;
          margin-bottom: 8px;
          border-radius: 4px;
          background: #fff;
          .progress-bar-content {
            height: 100%;
            border-radius: 4px;
            background: #fff600;
          }
        }
        b {
          color: #fff600;
        }
      }

      .task-completion {
        color: #fff600;
        padding-top: 15px;
        span {
          display: inline-block;
          padding-bottom: 5px;
          font-size: 18px;
          font-weight: 600;
        }
        div {
          padding: 1px;
          font-size: 12px;
          border: 1px solid #fff600;
          border-radius: 3px;
        }
      }
    }
  }

  .prize {
    padding-top: 25px;
    // margin-bottom: 30px;
    text-align: center;
    // background: rgba(144,147,153,.5);
    border-radius: 8px;
    .prize-title {
      width: 100%;
      margin-bottom: 30px;
      img {
        width: 70%;
      }
      // color: #fff600;
      // font-size: 18px;
      // font-weight: 600;
      // margin-bottom: 10px;
      // span:nth-child(1) {
      //   margin-right: 30px;
      // }
    }
    .prize-info {
      display: flex;
      justify-content: space-around;
      .prize-content {
        text-align: center;
        .prize-icon {
          img {
            width: 90px;
          }
        }
        .prize-name {
          line-height: 20px;
          font-size: 16px;
          font-weight: 600;
          color: #fff;
        }
        .prize-points {
          padding-bottom: 15px;
          line-height: 20px;
          font-size: 12px;
          color: #fff600;
        }
        .prize-btn {
          display: inline-block;
          padding: 5px;
          margin-bottom: 15px;
          border-radius: 10px;
          font-size: 12px;
          font-weight: 600;
          color: #aaa;
          background-color: #fff600;
        }
        .prize-detail {
          background-color: rgba(255,255,255,.6);
          padding: 10px 5px 15px;
          line-height: 30px;
          font-size: 14px;
          font-weight: 600;
          color: #fff;
          border-radius: 10px;
          .prize-detail-content {
            display: flex;
            justify-content: space-around;
            width: 140px;
            div {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border-radius: 10px;
              text-align: center;
              background-color: #fff;
              img {
                width: 100%;
                vertical-align: middle;
              }
            }
            .prize-special {
              display: flex;
              justify-content: space-around;
              box-sizing: border-box;
              width: 80px;
              height: 40px;
              color: #999;
              font-size: 14px;
              img {
                width: 35px;
                height: 35px;
                margin: auto;
              }
            }
          }
        }
      }
    }
  }

  .rule {
    padding: 0 15px;
    line-height: 18px;
    font-size: 12px;
    font-style: italic;
    color: #666;
    .rule-detail, .rule-prize {
      margin-bottom: 20px;
    }
    .rule-level1-heading {
      line-height: 30px;
      font-size: 14px;
      font-weight: 600;
    }
    .rule-secondary-heading {
      line-height: 25px;
    }
  }

  .floating {
    position: absolute;
    top: 60px;
    right: 0;
    img {
      width: 70px;
    }
  }

  .lottory {
    position: absolute;
    top: 30px;
    right: 0;
    height: 500px;
    width: 100px;
    pointer-events: none;
    overflow: hidden;
  }
  .lottory-wrapper {
    position: absolute;
    top: 0;
    right: -100px;
    transition: right .5s ease;
    pointer-events: auto;
    .lottory-icon {
      text-align: center;
      img {
        width: 25px;
      }
    }
    .lottory-content {
      padding: 10px;
      width: 80px;
      border-radius: 10px;
      text-align: center;
      background: rgba(255, 255, 255, .8);
    }
    img {
      width: 70px;
      padding-bottom: 10px;
    }
    .lottory-btn {
      width: 80px;
      padding-top: 10px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
